module.exports = __webpack_public_path__ + "static/muriwai-ccebceaf605ed9f3eab39aa4288248ed.jpg";